import React from 'react';

import cx from 'classnames';
import dateformat from 'dateformat';
import _ from 'lodash';

import { formatTimespent, formatName } from "../../../../services/report.service";
import { Col, Row } from 'react-bootstrap';

import styles from "../../reports.module.scss";
import entityStyles from "./styles.module.scss";

import DefaultAssetIcon from '../../../../images/defaultAsset.jpg';
import { localizedStrings } from "../../../../../localization/index"
import Truncate from 'src/components/truncate';

class UserListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      
    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    return (
      <span className={cx(styles.item, entityStyles.user, this.props.className)}>
        <img className={cx(styles.icon, entityStyles.icon)} src={_.get(this.props.item, 'user.icon.thumbnail') || DefaultAssetIcon} />
        <div>
          <h5 className={styles.title}>
            <Truncate width={300}>
              {formatName(this.props.item.user)}
              </Truncate>
            </h5>
          <ul className={styles.metrics}>
            <li>{_.get(this.props.item, 'analytics.views', 0)} {this.localizedTabsCommons.views}</li>
            <li>{formatTimespent(_.get(this.props.item, 'analytics.avgTimeSpent', 0))} {this.localizedTabsCommons.avg_time}</li>
            <li>{_.get(this.props.item, 'analytics.shares', 0)} {this.localizedTabsCommons.shares}</li>
          </ul>
          <div className={entityStyles.lastActive}>{this.localizedTabsCommons.last_active}: { _.get(this,"props.item.user.lastActivityDate") ? dateformat(this.props.item.user.lastActivityDate, 'dd mmm yyyy') : "N/A" }</div>
        </div>
      </span>
    );
  }
}

class UserGridItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      
    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    return (
      <Row className={styles.row}>
        <Col className={styles.column} md={6}>
          <a href="#" className={cx(styles.item, entityStyles.user, this.props.className)}>
            <img className={cx(styles.icon, entityStyles.icon)} src={_.get(this.props.item, 'user.icon.thumbnail') || DefaultAssetIcon} />
            <div>
              <h5 className={styles.title}>{formatName(this.props.item.user)}</h5>
              <ul className={styles.metrics}>
                <li>{this.localizedTabsCommons.joined}: {dateformat(this.props.item.user.createdDate, 'dd mmm yyyy')}</li>
                <li>{this.localizedTabsCommons.role}: {this.props.item.user.admin ? "Administrator" : "User"}</li>
              </ul>
              <div className={entityStyles.lastActive}>{this.localizedTabsCommons.last_active}: { _.get(this,"props.item.user.lastActivityDate") ? dateformat(this.props.item.user.lastActivityDate, 'dd mmm yyyy') : "N/A" }</div>
            </div>
          </a>
        </Col>
        <Col className={styles.column} md={2}>{_.get(this.props.item, 'analytics.views', 0)}</Col>
        <Col className={styles.column} md={2}>{formatTimespent(_.get(this.props.item, 'analytics.avgTimeSpent', 0))}</Col>
        <Col className={styles.column} md={2}>{_.get(this.props.item, 'analytics.shares', 0)}</Col>
      </Row>
    );
  }
}

const User = {};
User.List = UserListItem;
User.Grid = UserGridItem;

export default User;